import React, { FormEvent, HTMLInputTypeAttribute } from 'react'
import { useController, FieldError } from 'react-hook-form'
import * as S from './FieldV2.styles'

interface Props {
  labelText?: string | JSX.Element
  name: string
  control: any
  className?: string
  onInput?: (e: FormEvent) => void
  type?: HTMLInputTypeAttribute
  disabled?: boolean
  placeholder?: string
  onKeyDown?: any
  readOnly?: boolean
  showErrorContainer?: boolean
  flexDirection?: React.CSSProperties['flexDirection']
  testId?: string
  autoFocus?: boolean
  autoComplete?: string
  inputTextColor?: string
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>
}

const processError = (error: FieldError) => {
  if (error.type === 'typeError') {
    return { ...error, message: 'Caractere inesperado e inválido!' }
  }
  return error
}

export default React.memo(({
  labelText,
  name,
  control,
  className,
  onInput,
  type,
  disabled = false,
  placeholder,
  onKeyDown,
  readOnly,
  flexDirection,
  showErrorContainer = false,
  testId,
  autoFocus,
  autoComplete,
  inputTextColor = '#000',
  inputProps,
}: Props) => {
  const {
    field: {
      value, onChange, onBlur, ref,
    },
    fieldState: { error },
  } = useController({ name, control })

  const getValue = () => {
    if (!value) return ''
    if (value instanceof Date) {
      return value.toISOString().split('T')[0]
    }
    return value
  }

  const handleOnInput = (event: FormEvent) => {
    onInput?.(event)
    onChange(event)
  }

  return (
    <S.Wrapper className={className} style={{ flexDirection }}>
      {labelText && <S.Label htmlFor={name}>{labelText}</S.Label>}
      <S.Input
        textColor={inputTextColor}
        autoFocus={autoFocus}
        data-testid={testId}
        id={name}
        title={name}
        type={type}
        onInput={handleOnInput}
        onChange={onChange}
        onBlur={onBlur}
        value={getValue()}
        error={error}
        ref={ref}
        autoComplete={autoComplete}
        disabled={disabled}
        placeholder={placeholder}
        onKeyDown={onKeyDown}
        readOnly={readOnly}
        {...inputProps}
      />
      {(showErrorContainer || error) && <S.Error>{error && processError(error).message}</S.Error>}
    </S.Wrapper>
  )
})
